import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, message, Upload, UploadProps, Col, Row, Modal } from 'antd';
import { UploadFile } from 'antd/es/upload/interface';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { MessageType } from 'models/MessageType';
import { hasUploadedFile } from 'components/form';
import { RcFile } from 'antd/es/upload';
import uploudlistIcon from 'assets/images/Image file.svg';
// import { reject } from 'lodash';
import './style.less';
import { useMediaQuery } from 'react-responsive';
const TEN_MB = 10 * 1024 * 1024;
const MAX_PER_FILE_SIZE = TEN_MB;
const MAX_SIZE = TEN_MB * 10;
const MAX_NUMBER_OF_ATTACHMENTS = 12;
type DocumentsCardType = {
  setInvalid: (invalid: boolean) => void;
};
export const DocumentsCard = ({ setInvalid }: DocumentsCardType) => {
  const isLargeScreen = useMediaQuery({ minWidth: 768 });
  const { t } = useTranslation();
  const [exceedNo, setExceedNo] = useState(false);
  const [exceedSize, setExceedSize] = useState(false);
  const [attachments, setAttachments] = useState<UploadFile[]>([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const margin = screenWidth - 428 < 200 ? 0 : 100;

  useEffect(() => {
    setInvalid(exceedSize || exceedNo);
  }, [exceedNo, exceedSize, setInvalid]);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [subdelet, setsubdelet] = useState(false);

  // const handleOk = () => {
  //   setsubdelet(true);
  //   setIsModalOpen(false);
  // };

  // const handleCancel = () => {
  //   setsubdelet(false);
  //   setIsModalOpen(false);
  // };
  // useEffect(() => {}, [subdelet]);

  const attachmentUploadProps: UploadProps = useMemo(
    () => ({
      fileList: attachments,
      listType: 'picture',
      multiple: false,
      accept: '.png,.jpg,.pdf,.zip,.doc,.docx,.xls,.xlsx,.txt,.*',
      onChange: ({ fileList }) => {
        const totalSize = fileList.map((a) => a.size || 0).reduce((acc, cur) => acc + cur, 0);
        setExceedSize(totalSize > MAX_SIZE);
        setExceedNo(fileList.length > MAX_NUMBER_OF_ATTACHMENTS);
        setAttachments(fileList);
      },
      // onRemove: () => {
      //   setIsModalOpen(true);
      //   if (subdelet) {
      //     return new Promise((resolve) => {
      //       setsubdelet(false);
      //       return resolve(true);
      //     });
      //   } else {
      //     return new Promise((reject) => {
      //       setsubdelet(false);
      //       return reject;
      //     });
      //   }
      // },
      onPreview: () => {
        // console.log(111111111);
      },
      onRemove: () => {
        return new Promise((resolve) => {
          Modal.confirm({
            title: '',
            icon: '',
            width: 510,
            centered: true,
            className: 'Modalconfirm',
            okText: `${t('life.enquiry.Cancel')}`,
            cancelText: `${t('life.enquiry.delete')}`,
            content: `${t('life.enquiry.sureToDelete')}`,
            onOk: () => {
              return false;
            },
            onCancel: () => {
              return resolve(true);
            },
          });
        });
      },

      beforeUpload: (f) => {
        if (hasUploadedFile(attachments as RcFile[], f)) {
          message[MessageType.ERROR](t('common.error.notAllowUploadSameDocument'));
          return Upload.LIST_IGNORE;
        }

        if (f.size > MAX_PER_FILE_SIZE) {
          message[MessageType.ERROR](t('common.error.sizeExceeds', { amount: 10 }));
          return Upload.LIST_IGNORE;
        }
        return false;
      },
    }),
    [attachments, t],
  );

  return (
    <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]}>
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          name="attachments"
          // label={
          //   <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
          //     {t('life.enquiry.Supplementary')}
          //   </span>
          // }
        >
          <Upload
            className="customUpload"
            name="documents"
            maxCount={5}
            {...attachmentUploadProps}
            iconRender={() => <img src={uploudlistIcon} width={24} height={24} alt="upload list icon" />}
          >
            <div>
              <Button
                style={{
                  marginLeft: `${margin}px`,
                  marginRight: `${margin}px`,
                  fontFamily: 'Roboto500',
                  fontSize: '20px',
                  height: '56px',
                  width: isLargeScreen ? '428px' : '350px',
                  // maxWidth: '100%',
                  color: '#C21B17',
                  border: '1px solid #C21B17',
                }}
                disabled={attachments.length == 5}
              >
                {t('enquiry.upload')}
              </Button>

              {attachments.length > 0 && (
                <div
                  style={{
                    color: '#B0B2B3',
                    fontWeight: 'normal',
                    fontSize: '17px',
                    fontFamily: 'Roboto400',
                    marginTop: '20px',
                  }}
                >
                  {t('life.enquiry.uploadedAttr1')}
                </div>
              )}
            </div>
          </Upload>
        </BoldLabelFormItem>
        {/* <Modal
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[
            <Button key="submit" type="primary" onClick={handleOk} className="modalConfrim">
              {t('life.enquiry.delete')}
            </Button>,
            <Button key="back" onClick={handleCancel} className="modalConcel">
              {t('life.enquiry.Cancel')}
            </Button>,
          ]}
        >
          <span style={{ fontFamily: 'Roboto400', fontSize: '17px', color: '#C21B17' }}>
            {t('life.enquiry.sureToDelete')}
          </span>
        </Modal> */}
      </Col>
    </Row>
  );
};
